import { CallableToggle } from "Components/Shared";
import { Field, Formik } from "formik";
import { useNumberPool } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Form,
  Header,
  Menu,
  Segment,
} from "semantic-ui-react";
import { boolean, object } from "yup";

type ConfirmSelectNumberProps = {
  onAssign: Function;
};

const ConfirmSelectNumber = ({ onAssign }: ConfirmSelectNumberProps) => {
  const { ddi, unselect, assign } = useNumberPool();

  async function assignPoolNumber() {
    await assign();
    onAssign();
  }

  return (
    <Container textAlign='left' fluid>
      <Menu fluid stackable>
        <Menu.Item>
          <Breadcrumb>
            <Breadcrumb.Section link onClick={() => unselect()}>
              Number Pool
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>Assign</Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>{ddi.name}</Breadcrumb.Section>
          </Breadcrumb>
        </Menu.Item>
        <Menu.Item></Menu.Item>
      </Menu>
      <Segment>
        <Formik
          initialValues={{ ddi: ddi, terms: false }}
          validationSchema={object().shape({
            terms: boolean().oneOf(
              [true],
              "Please accept terms and conditions"
            ),
          })}
          onSubmit={(values, actions) => {
            assignPoolNumber();
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Header as='h2'>Assign DDI</Header>

              <Field
                name='terms'
                label='I understand that by assigning this number, it will be billed at the agreed rate.'
                component={CallableToggle}
              />

              <Button primary type='submit' disabled={!isEmpty(props.errors)}>
                Assign Number
              </Button>
            </Form>
          )}
        </Formik>
      </Segment>
    </Container>
  );
};

export default ConfirmSelectNumber;
